import { CLICKS, LEADS } from 'consts';

const productTypesHash = {
  [LEADS]: 'lead',
  [CLICKS]: 'click',
};

Object.keys(productTypesHash).forEach((key) => {
  const value = productTypesHash[key];
  productTypesHash[value] = key;
});

export const switchProductType = (key) => {
  return productTypesHash[key];
};

const buyerHash = { [LEADS]: 'isLeadBuyer', [CLICKS]: 'isClickBuyer' };

Object.keys(buyerHash).forEach((key) => {
  const value = buyerHash[key];
  buyerHash[value] = key;
});

export const getBuyerProductTypes = (buyer) => {
  const res = [];
  if (!buyer) return res;

  [LEADS, CLICKS].forEach((productType) => {
    if (buyer[buyerHash[productType]]) {
      res.push(productType);
    }
  });

  return res;
};

export { buyerHash };
